import { CheckCircle2, Archive, HelpCircle } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { PbiReviewStatus } from '../../types/powerBiUsage';

export const PBI_REVIEW_ORDER: PbiReviewStatus[] = ['Keep', 'Retire', 'Undecided'];

interface ReviewMeta {
    label: string;
    icon: LucideIcon;
    iconClass: string;
    tileClass: string;
    badgeClass: string;
}

export const PBI_REVIEW_META: Record<PbiReviewStatus, ReviewMeta> = {
    Keep: {
        label: 'Keep',
        icon: CheckCircle2,
        iconClass: 'text-green-600',
        tileClass: 'text-green-600',
        badgeClass: 'border-green-200 bg-green-50 text-green-700',
    },
    Retire: {
        label: 'Retire',
        icon: Archive,
        iconClass: 'text-red-600',
        tileClass: 'text-red-600',
        badgeClass: 'border-red-200 bg-red-50 text-red-700',
    },
    Undecided: {
        label: 'Undecided',
        icon: HelpCircle,
        iconClass: 'text-gray-400',
        tileClass: 'text-gray-500',
        badgeClass: 'border-gray-200 bg-gray-50 text-gray-600',
    },
};

/** A report without a review row is Undecided. */
export function toReviewStatus(raw: string | null | undefined): PbiReviewStatus {
    return raw === 'Keep' || raw === 'Retire' ? raw : 'Undecided';
}
